export default "__VITE_ASSET__CLvJC9aP__"